/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ApplicationStatus {
  UNDER_REVIEW = 'under_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PURGED = 'purged',
  IN_PROGRESS = 'in_progress',
  CANCELLED = 'cancelled',
  PENDING_PAYMENT = 'pending_payment',
  CERTIFICATE_ISSUED = 'certificate_issued',
}
